(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function initCalculator(root) {
    var calc = qs(root, '[data-fw-vr-calculator]');
    if (!calc) return;
    var range = qs(calc, '[data-fw-vr-spend-range]');
    var outPoints = qs(calc, '[data-fw-vr-out-points]');
    var outDollars = qs(calc, '[data-fw-vr-out-dollars]');
    var outSpend = qs(calc, '[data-fw-vr-spend-display]');
    var chips = calc.querySelectorAll('[data-fw-vr-spend-chip]');
    var rate = parseFloat(calc.getAttribute('data-fw-vr-points-rate')) || 520;
    var divisor = parseFloat(calc.getAttribute('data-fw-vr-dollar-divisor')) || 1000;

    function formatNum(n) {
      return Math.round(n).toLocaleString('en-CA');
    }

    function update(val) {
      var spend = parseInt(val, 10) || 0;
      if (range) {
        range.value = String(spend);
        range.setAttribute('aria-valuenow', String(spend));
        range.setAttribute('aria-valuetext', '$' + spend + ' a week');
      }
      var yearly = spend * rate;
      var dollars = yearly / divisor;
      if (outSpend) outSpend.textContent = '$' + formatNum(spend);
      if (outPoints) outPoints.textContent = formatNum(yearly);
      if (outDollars) outDollars.textContent = '$' + formatNum(dollars);
      chips.forEach(function (chip) {
        var chipVal = chip.getAttribute('data-fw-vr-spend-chip');
        chip.classList.toggle('is-active', String(spend) === chipVal);
        chip.setAttribute('aria-pressed', String(spend) === chipVal ? 'true' : 'false');
      });
    }

    if (range) {
      range.addEventListener('input', function () {
        update(range.value);
      });
      update(range.value);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        update(chip.getAttribute('data-fw-vr-spend-chip'));
      });
    });
  }

  function initSignupTags() {
    var form = qs(document, '#fw-vr-signup-form');
    if (!form) return;
    var tagsInput = qs(form, '[data-fw-vr-contact-tags]');
    var consent = qs(form, '[data-fw-vr-consent]');
    form.addEventListener('submit', function () {
      if (!tagsInput) return;
      tagsInput.value = consent && consent.checked ? 'variety-rewards, accepts-marketing' : 'variety-rewards';
    });
  }

  function showFieldError(input, message) {
    if (!input) return;
    var errorId = input.getAttribute('data-fw-vr-error-id');
    var errorEl = errorId ? document.getElementById(errorId) : null;
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', errorId);
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
      input.removeAttribute('aria-invalid');
      if (input.getAttribute('aria-describedby') === errorId) {
        input.removeAttribute('aria-describedby');
      }
    }
  }

  function validateEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
  }

  function initSignupValidation() {
    var form = qs(document, '#fw-vr-signup-form');
    if (!form) return;

    function validateInput(input) {
      var kind = input.getAttribute('data-fw-vr-field');
      var val = input.value.trim();
      if (kind === 'required') {
        if (!val) {
          showFieldError(input, 'This field is required.');
          return false;
        }
        showFieldError(input, '');
        return true;
      }
      if (kind === 'email') {
        if (!val) {
          showFieldError(input, 'Email is required.');
          return false;
        }
        if (!validateEmail(val)) {
          showFieldError(input, 'Enter a valid email address.');
          return false;
        }
        showFieldError(input, '');
        return true;
      }
      if (kind === 'postal') {
        if (!val) {
          showFieldError(input, '');
          return true;
        }
        if (/^abc$/i.test(val)) {
          showFieldError(input, 'Enter a valid postal code.');
          return false;
        }
        var patternRaw = input.getAttribute('data-fw-vr-postal-pattern');
        if (patternRaw) {
          try {
            var re = new RegExp(patternRaw);
            if (!re.test(val)) {
              showFieldError(input, 'Enter a valid postal code.');
              return false;
            }
          } catch (e) {
            /* invalid merchant regex — skip pattern check */
          }
        }
        showFieldError(input, '');
        return true;
      }
      return true;
    }

    form.querySelectorAll('[data-fw-vr-field]').forEach(function (input) {
      input.addEventListener('blur', function () {
        validateInput(input);
      });
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') {
          validateInput(input);
        }
      });
    });

    form.addEventListener('submit', function (e) {
      var ok = true;
      form.querySelectorAll('[data-fw-vr-field]').forEach(function (input) {
        if (!validateInput(input)) ok = false;
      });
      if (!ok) e.preventDefault();
    });
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href="#vr-signup"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('vr-signup');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    if (!document.querySelector('.template-fw-variety-rewards')) return;
    initCalculator(document);
    initSignupTags();
    initSignupValidation();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
